export const MATCH_EXACT_RELEASE = 0;
export const MATCH_MAJOR_RELEASE = 1;
export const MATCH_MINOR_RELEASE = 2;
export const MATCH_PATCH_RELEASE = 3;

export class SemanticVersion {
    constructor(versionStr) {
        if (versionStr === '*' || versionStr === 'x') {
            this.versionStr = '';
            this.mode = MATCH_MAJOR_RELEASE;
        } else if (versionStr.startsWith('^')) {
            this.versionStr = versionStr.substring(1);
            this.mode = MATCH_MINOR_RELEASE;
        } else if (versionStr.startsWith('~')) {
            this.versionStr = versionStr.substring(1);
            this.mode = MATCH_PATCH_RELEASE;
        } else {
            this.versionStr = versionStr;
            this.mode = MATCH_EXACT_RELEASE;
        }
        [this.major, this.minor, this.patch] = this.versionStr.split('.').map(s => parseInt(s));
    }

    // test if other semantic version is compatible with this semantic version,
    // only mode of this semantic version is considered, the mode of other
    // semantic version is ignored, so a.match(b) may not equal b.match(a)
    match(other) {
        if (this.mode === MATCH_MAJOR_RELEASE) {
            return true;
        } else if (this.mode === MATCH_MINOR_RELEASE) {
            return this.major === other.major
                && SemanticVersion.compare(this, other) <= 0;
        } else if (this.mode === MATCH_PATCH_RELEASE) {
            return this.major === other.major
                && this.minor === other.minor
                && SemanticVersion.compare(this, other) <= 0;
        } else {
            return SemanticVersion.compare(this, other) === 0;
        }
    }

    static compare(a, b) {
        if (a.mode === MATCH_MAJOR_RELEASE || b.mode === MATCH_MAJOR_RELEASE) {
            throw new Error('cannot compare semantic versions with MATCH_MAJOR_RELEASE mode');
        } else if (a.major !== b.major) {
            return a.major > b.major ? 1 : -1;
        } else if (a.minor !== b.minor) {
            return a.minor > b.minor ? 1 : -1;
        } else if (a.patch !== b.patch) {
            return a.patch > b.patch ? 1 : -1;
        } else {
            return 0;
        }
    }

    static condenseExactAndMinorVersionRequirements(requirements) {
        const matchExactVersions = [];
        const matchMinorVersions = [];

        // parse requirements
        requirements.forEach(r => {
            const v = new SemanticVersion(r);
            if (v.mode === MATCH_EXACT_RELEASE) {
                matchExactVersions.push(v);
            } else if (v.mode === MATCH_MINOR_RELEASE) {
                matchMinorVersions.push(v);
            } else {
                throw new Error(`unsupported version format, version: ${r}`);
            }
        });

        // merge match minor version requirements
        let requirement = null
        if (matchMinorVersions.length) {
            matchMinorVersions.sort(SemanticVersion.compare);
            const first = matchMinorVersions[0];
            const last = matchMinorVersions[matchMinorVersions.length - 1];
            if (first.major !== last.major) {
                throw new Error(`conflicting version requirements ${requirements}`);
            }
            requirement = last;
        }

        // deal with exact version requirements
        if (matchExactVersions.length) {
            const exactVersion = matchExactVersions[0];
            matchExactVersions.forEach(v => {
                if (SemanticVersion.compare(exactVersion, v) !== 0) {
                    throw new Error(`conflicting version requirements: ${requirements}`);
                }
            });
            if (requirement && !requirement.match(exactVersion)) {
                throw new Error(`conflicting version requirements: ${requirements}`);
            };
            return exactVersion;
        } else if (requirement) {
            return requirement;
        } else {
            throw new Error(`no version meets requirements ${requirement}`);
        }
    }
}